import { op } from "libs/transaction";
import { createAction } from "./action";
import { RecordValue, getPointer } from "libs/schema";

/* -------------------------------------------------------------------------------------------------
 *  updateUserSettings
 * -------------------------------------------------------------------------------------------------
 */

type UpdateUserSettingsProps = {
  settings: RecordValue<"user_settings">["settings"];
};

export const updateUserSettings = createAction<UpdateUserSettingsProps>("updateUserSettings.updateUserSettings", {
  operations: async (props, context) => {
    return op.update(getPointer("user_settings", context.currentUserId), "settings", props.settings);
  },
  authorize: async () => {
    // Users are permitted to update their own user_settings record, and the current implementation
    // with `context.currentUserId` ensures that only this record can be updated, so no authorization is necessary.
  },
});

export const actions = {
  updateUserSettings,
};
